import { Button, CustomDatePicker, Text, XStack } from '@my/ui'
import { Calendar } from '@tamagui/lucide-icons'
import { DateTime } from 'luxon'
import React from 'react'

interface TaskDatePickerProps {
  value: string | null
  onChange: (date: string | null) => void
  placeholder: string
}

const DatePickerFooter = ({ onClose, onClear }: { onClose: () => void; onClear: () => void }) => (
  <XStack justifyContent="space-between" paddingVertical="$2" paddingHorizontal="$2" marginTop="$2">
    <Button variant="outlined" onPress={onClose} paddingHorizontal="$3" height="$3" borderColor="$accentColor" borderRadius="$8">
      <Text color="$accentColor" fontSize="$3">Cancel</Text>
    </Button>
    <Button variant="outlined" onPress={onClear} paddingHorizontal="$3" height="$3" borderColor="$accentColor" borderRadius="$8">
      <Text color="$accentColor" fontSize="$3">Clear</Text>
    </Button>
  </XStack>
)

export function TaskDatePicker({ value, onChange, placeholder }: TaskDatePickerProps) {
  //console.log('TaskDatePicker: value', value)
  const formatDate = (date: string | null) => {
    if (!date) return ''
    return DateTime.fromISO(date).toFormat('MMM d')
  }

  const TriggerButton = ({ value, placeholder, onPress }: { value: string | null; placeholder: string; onPress: () => void }) => (
    <XStack
      borderWidth={value ? 2.5 : 2.5}
      borderColor={value ? '$accentColor' : '$color5'}
      paddingVertical="$1.5"
      paddingHorizontal="$2.5"
      borderRadius="$2"
      gap="$2"
      alignItems="center"
      alignSelf="flex-start"
      flexShrink={1}
      flexGrow={0}
      maxWidth="100%"
      cursor="pointer"
      hoverStyle={{ backgroundColor: '$color1' }}
      onPress={onPress}
    >
      <Calendar strokeWidth={2.5} size={16} color={value ? '$accentColor' : '$color6'} />
      <Text fontSize="$3" fontWeight={value ? '500' : '500'} color={value ? '$accentColor' : '$color6'}>
        {value ? formatDate(value) : placeholder}

      </Text>
    </XStack>
  )

  return (
    <CustomDatePicker
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      triggerComponent={TriggerButton}
      footer={DatePickerFooter}
      popoverOffset={-150}
    />
  )
}
